import React, { InputHTMLAttributes } from "react";

import { Container } from "./styles";

const VuiRadio = ({ label, name, ...props }) => {
  return (
    <Container className="containerRadio">
      <p>
        <input type="radio" id={name} name={name} {...props} />
        <label htmlFor={name}>{label}</label>
      </p>
    </Container>
  );
};

export default VuiRadio;
